import { render, staticRenderFns } from "./ExtensionView.vue?vue&type=template&id=55693881&"
import script from "./ExtensionView.vue?vue&type=script&lang=js&"
export * from "./ExtensionView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports